export type QiCreatePrefillSearch = {
  type?: string;
  productId?: string;
  rawMaterialId?: string;
  qty?: number;
  stockBranchId?: string;
  productCode?: string;
  productName?: string;
  unitPrice?: number;
  unit?: string;
  source?: string;
  sourceRef?: string;
};

export type DocumentCreateStockPrefill = {
  documentType: string;
  stockBranchId?: string;
  notes?: string | null;
  line?: {
    productId?: string;
    rawMaterialId?: string;
    quantity: number;
    unitPrice?: number;
    unit?: string;
    productCode?: string;
    productName?: string;
    description?: string;
  };
};

function parseOptionalNumber(value: unknown): number | undefined {
  if (value == null || value === "") return undefined;
  const n = Number(value);
  return Number.isFinite(n) ? n : undefined;
}

export function parseQiCreatePrefillSearch(
  search: Record<string, unknown>,
): QiCreatePrefillSearch {
  return {
    type: typeof search.type === "string" ? search.type : undefined,
    productId:
      typeof search.productId === "string" ? search.productId : undefined,
    rawMaterialId:
      typeof search.rawMaterialId === "string"
        ? search.rawMaterialId
        : undefined,
    qty: parseOptionalNumber(search.qty),
    stockBranchId:
      typeof search.stockBranchId === "string"
        ? search.stockBranchId
        : undefined,
    productCode:
      typeof search.productCode === "string" ? search.productCode : undefined,
    productName:
      typeof search.productName === "string" ? search.productName : undefined,
    unitPrice: parseOptionalNumber(search.unitPrice),
    unit: typeof search.unit === "string" ? search.unit : undefined,
    source: typeof search.source === "string" ? search.source : undefined,
    sourceRef:
      typeof search.sourceRef === "string" ? search.sourceRef : undefined,
  };
}

export function buildDocumentCreateStockPrefill(
  search: QiCreatePrefillSearch,
): DocumentCreateStockPrefill | null {
  const hasLine = Boolean(search.productId || search.rawMaterialId);
  const hasHeader = Boolean(search.stockBranchId || search.type);
  if (!hasLine && !hasHeader) return null;

  const description =
    search.productCode && search.productName
      ? `${search.productCode} — ${search.productName}`
      : search.productName ?? search.productCode;

  const notes =
    search.source === "stock_pos" && search.sourceRef
      ? `Prefill from Stock POS (${search.sourceRef})`
      : undefined;

  return {
    documentType: search.type?.trim() || "quotation",
    stockBranchId: search.stockBranchId,
    notes,
    line: hasLine
      ? {
          productId: search.productId,
          rawMaterialId: search.rawMaterialId,
          quantity: search.qty != null && search.qty > 0 ? search.qty : 1,
          unitPrice: search.unitPrice,
          unit: search.unit,
          productCode: search.productCode,
          productName: search.productName,
          description,
        }
      : undefined,
  };
}

export const qiCreatePrefillValidateSearch = (
  search: Record<string, unknown>,
) => parseQiCreatePrefillSearch(search);
